import React from 'react';

export const messageContext = React.createContext<{
  mode: 'flatten' | 'nested';
}>({
  mode: 'nested',
});

export const MessageProvider = messageContext.Provider;
